import React from 'react';
import PropTypes from 'prop-types';

import SendSmsButton from './SendSmsButton';
import { useConstantContext } from './ConstantsContext';

const SendReminderSmsButton = ({
  userId,
}) => {
  const { constants } = useConstantContext();
  const { smsTypes } = constants;
  return (
    <SendSmsButton
      title="Send reminder sms"
      userId={userId}
      smsType={smsTypes.LATE_REMINDER}
    />
  );
};

SendReminderSmsButton.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default SendReminderSmsButton;
